// @ngInject

Models.TimelineItemsCollection = function TimelineItemsCollection(BaseCollection) {

    return Class(BaseCollection, {

            constructor: function constructor() {
                this.constructor.$super.call(this);
                this._collection.__className = 'TimelineItemsCollection';
                this._collection.__childsType = 'TimelineItemModel';
                return this._collection;
            }
        }
    );

};